module.exports = __webpack_public_path__ + "img/close-x-grey.f853f218.svg";